module.exports = __webpack_public_path__ + "public/img/xinwen.092fd098.png";